<template>
	<div>
		<sui-modal v-model="openExpedienteFisico" :size="'small'">
			<sui-modal-header>
				<slot name="titulo">
					<strong class="blackFont">E.Titulo</strong>
				</slot>
				<i
					style="float: right; cursor: pointer;"
					class="close icon"
					@click="closeModalExpedienteFisico"
				></i>
			</sui-modal-header>
			<sui-modal-content scrolling>
				<sui-modal-description>
					<sui-header>
						<sui-grid>
							<sui-grid-row>
								<sui-grid-column :width="16">
									<form class="ui reply form">
										<div class="field">
											<label>Numero paquete</label>
											<input v-model="numeroPaquete" type="text" />
										</div>
										<div class="field">
											<label>Observaciones</label>
											<textarea v-model="observacionesExpediente"></textarea>
										</div>
									</form>
								</sui-grid-column>
							</sui-grid-row>
						</sui-grid>
					</sui-header>
				</sui-modal-description>
			</sui-modal-content>
			<sui-modal-actions style="padding: 0 !important;">
				<BaseButton
					style-button="primary"
					style="margin: 10px"
					style-class="right floated"
					@click.native="guardarExpediente"
					>Guardar</BaseButton
				>
				<BaseButton
					style-button="secondary"
					style="margin: 10px"
					style-class="right floated"
					@click.native="closeModalExpedienteFisico"
					>Cerrar</BaseButton
				>
			</sui-modal-actions>
		</sui-modal>
		<sui-modal v-model="openOpcionTitulacion" :size="'small'">
			<sui-modal-header>
				<slot name="titulo">
					<strong class="blackFont"
						>Restablecer de opción de tituliación</strong
					>
				</slot>
				<i
					style="float: right; cursor: pointer;"
					class="close icon"
					@click="closeModalOpcionTitulacion"
				></i>
			</sui-modal-header>
			<sui-modal-content scrolling>
				<sui-modal-description>
					<sui-header>
						<sui-grid>
							<sui-grid-row>
								<sui-grid-column :width="16">
									<h3
										>¿Esta seguro que desea restablecer la opción de
										titulación?</h3
									>
								</sui-grid-column>
							</sui-grid-row>
						</sui-grid>
					</sui-header>
				</sui-modal-description>
			</sui-modal-content>
			<sui-modal-actions style="padding: 0 !important;">
				<BaseButton
					style-button="primary"
					style="margin: 10px"
					style-class="right floated"
					@click.native="restablecerOpcionTitulacionAlumno"
					>Si</BaseButton
				>
				<BaseButton
					style-button="secondary"
					style="margin: 10px"
					style-class="right floated"
					@click.native="closeModalOpcionTitulacion"
					>No</BaseButton
				>
			</sui-modal-actions>
		</sui-modal>

		<sui-modal v-model="openPdfNoInconvenientes" size="large">
			<sui-modal-header>
				<slot name="titulo">
					<strong class="blackFont">Documento de no inconvenientes</strong>
				</slot>
				<i
					style="float: right; cursor: pointer;"
					class="close icon"
					@click="closePdfNoInconvenientes"
				></i>
			</sui-modal-header>
			<sui-modal-content scrolling>
				<sui-modal-description>
					<sui-header>
						<sui-grid>
							<sui-grid-row>
								<sui-grid-column :width="16">
									<iframe
										:src="`${urlArchivoPdfNoInconvenientes}`"
										type="application/pdf"
										width="100%"
										height="700px"
									></iframe>
								</sui-grid-column>
							</sui-grid-row>
						</sui-grid>
					</sui-header>
				</sui-modal-description>
			</sui-modal-content>
			<sui-modal-actions style="padding: 0 !important;">
				<BaseButton
					style-button="primary"
					style="margin: 10px"
					style-class="right floated"
					:disabled="isLoadingFormulario"
					:class="`${isLoadingFormulario ? 'disabled' : ''}`"
					@click.native="aceptarArchivoPdfNoInconvenientes"
					>Enviar al alumno</BaseButton
				>
				<BaseButton
					style-button="secondary"
					style="margin: 10px"
					style-class="right floated"
					@click.native="closePdfNoInconvenientes"
					>Cerrar</BaseButton
				>
			</sui-modal-actions>
		</sui-modal>
		<sui-modal v-model="openCorreo" :size="'small'">
			<sui-modal-header>
				<slot name="titulo">
					<strong class="blackFont">Enviar activación</strong>
				</slot>
				<i
					style="float: right; cursor: pointer;"
					class="close icon"
					@click="closeModalCorreo"
				></i>
			</sui-modal-header>
			<sui-modal-content scrolling>
				<sui-modal-description>
					<sui-header>
						<sui-grid>
							<sui-grid-row>
								<sui-grid-column :width="16">
									<form class="ui reply form">
										<div class="field">
											<label>Correo</label>
											<input v-model="correo" type="email" />
										</div>
										<div
											v-show="!dominioValido(correo)"
											class="ui bottom visible warning message"
											style="padding: 0.6em 1em;"
										>
											<i class="icon info circle"></i>
											Ingresa un correo institulacional valido.
										</div>
									</form>
								</sui-grid-column>
							</sui-grid-row>
						</sui-grid>
					</sui-header>
				</sui-modal-description>
			</sui-modal-content>
			<sui-modal-actions style="padding: 0 !important;">
				<BaseButton
					style-button="primary"
					style="margin: 10px"
					style-class="right floated"
					:disabled="!dominioValido(correo)"
					@click.native="activar"
					>Enviar</BaseButton
				>
				<BaseButton
					style-button="secondary"
					style="margin: 10px"
					style-class="right floated"
					@click.native="closeModalCorreo"
					>Cerrar</BaseButton
				>
			</sui-modal-actions>
		</sui-modal>

		<sui-modal v-model="openMensaje" :size="'small'">
			<sui-modal-header>
				<slot name="titulo">
					<strong class="blackFont">Enviar mensaje</strong>
				</slot>
				<i
					style="float: right; cursor: pointer;"
					class="close icon"
					@click="closeModalMensaje"
				></i>
			</sui-modal-header>
			<sui-modal-content scrolling>
				<sui-modal-description>
					<sui-header>
						<sui-grid>
							<sui-grid-row>
								<sui-grid-column :width="16">
									<div class="ui segment">
										<div class="ui small comments">
											<div v-for="msj in getMensajes" :key="msj.id">
												<div class="comment">
													<div class="content">
														<a class="author">{{ msj.personal }}</a>
														<div class="metadata">
															<span class="date">{{
																msj.fecha | datetime
															}}</span>
														</div>
														<div
															class="text"
															style=" padding: 5px;background: rgb(0 0 0 / 5%); border-radius: 5px;"
														>
															{{ msj.mensaje }}
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											v-show="getMensajes.length > 0"
											class="ui divider"
										></div>
										<form class="ui reply form">
											<div class="field">
												<label>Mensaje</label>
												<textarea v-model="mensaje" rows="2"></textarea>
											</div>
										</form>
									</div>
								</sui-grid-column>
							</sui-grid-row>
						</sui-grid>
					</sui-header>
				</sui-modal-description>
			</sui-modal-content>
			<sui-modal-actions style="padding: 0 !important;">
				<BaseButton
					style-button="primary"
					style="margin: 10px"
					style-class="right floated"
					@click.native="enviarMensaje"
					>Enviar</BaseButton
				>
				<BaseButton
					style-button="secondary"
					style="margin: 10px"
					style-class="right floated"
					@click.native="closeModalMensaje"
					>Cerrar</BaseButton
				>
			</sui-modal-actions>
		</sui-modal>
		<sui-modal v-model="openHistorico" :size="'small'">
			<sui-modal-header>
				<slot name="titulo">
					<strong class="blackFont">Histórico</strong>
				</slot>
				<i
					style="float: right; cursor: pointer;"
					class="close icon"
					@click="closeModalHistorico"
				></i>
			</sui-modal-header>
			<sui-modal-content scrolling>
				<sui-modal-description>
					<sui-header>
						<sui-grid>
							<sui-grid-row>
								<sui-grid-column :width="16">
									<div class="ui segment">
										<div class="ui small comments">
											<div
												v-for="historico in getHistoricos"
												:key="historico.id"
											>
												<div class="comment">
													<div class="content">
														<a class="author">{{ historico.usuario }}</a>
														<div class="metadata">
															<span class="date">{{
																historico.fecha | datetime
															}}</span>
														</div>
														<div
															class="text"
															style=" padding: 5px;background: rgb(0 0 0 / 5%); border-radius: 5px;"
														>
															{{ historico.accion }}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</sui-grid-column>
							</sui-grid-row>
						</sui-grid>
					</sui-header>
				</sui-modal-description>
			</sui-modal-content>
			<sui-modal-actions style="padding: 0 !important;">
				<BaseButton
					style-button="secondary"
					style="margin: 10px"
					style-class="right floated"
					@click.native="closeModalHistorico"
					>Cerrar</BaseButton
				>
			</sui-modal-actions>
		</sui-modal>
		<h2 class="ui center aligned icon header">
			<div class="content">
				<div class="sub header"
					>DEPARTAMENTO DE SERVICIOS ESCOLARES - OFICINA DE SERVICIOS
					ESTUDIANTILES</div
				>
				DOCUMENTOS PARA INTEGRAR EXPEDIENTE DE TITULACIÓN INTEGRAL
			</div>
		</h2>
		<div class="ui tree column grid">
			<div class="row">
				<div class="eight wide column">
					<div class="ui action input" style="width:100%">
						<input
							v-model="filter"
							type="text"
							placeholder="Buscar..."
							@keypress.enter="buscar"
						/>
						<button class="ui icon button" @click="buscar">
							<i class="search icon"></i>
						</button>
					</div>
				</div>
				<div class="four wide column">
					<base-select-pasos v-model="paso" />
				</div>
				<div class="four wide column">
					<base-select-carreras v-model="carrera" />
				</div>
			</div>
		</div>
		<br />
		<br />
		<sui-segment v-if="isLoading">
			<br />
			<br />
			<sui-loader active indeterminate>Buscando alumnos... </sui-loader>
			<br />
		</sui-segment>
		<sui-accordion v-if="!isLoading" exclusive styled style="width:100%">
			<sui-accordion-title
				v-if="elementosMostrar.length === 0"
				style="text-align: center;"
			>
				Sin registros para mostrar
			</sui-accordion-title>
			<template v-for="alumno in elementosMostrar">
				<sui-accordion-title
					:key="`title-${alumno.numeroControl}`"
					@click="onClickTitle(alumno.numeroControl)"
				>
					<sui-icon
						v-show="alumno.estatus"
						:name="
							`ui lock open ${alumno.estatus ? 'green' : 'grey'} right floated`
						"
					/>
					<sui-icon
						v-show="!alumno.estatus"
						:name="`ui lock ${alumno.estatus ? 'green' : 'grey'} right floated`"
					/>
					<i
						v-show="alumno.prioritario"
						class="ui icon star yellow small "
						title="Prioritario"
					></i>
					<span
						v-show="alumno.seguimiento"
						:class="`ui mini label button red right floated`"
						>CORRECCIÓN</span
					>
					<span
						:class="
							`ui mini label button ${faceColorLabel(
								alumno.stepActive,
								alumno.expedienteFisico
							)} right floated`
						"
						>{{ face(alumno.stepActive, alumno.expedienteFisico) }}</span
					>
					<sui-icon name="dropdown" />
					{{ alumno.numeroControl }} - {{ alumno.nombre }}
					{{ alumno.apellido_Paterno }} {{ alumno.apellido_Materno }}
				</sui-accordion-title>
				<sui-accordion-content :key="`content-${alumno.numeroControl}`">
					<div
						v-show="isLoading"
						class="ui"
						style="position:relative;height: 600px;"
					>
						<div style="z-index: 0;" class="ui inverted active dimmer">
							<div class="ui centered inline loader text">Cargando</div>
						</div>
					</div>
					<p v-show="!isLoading">
						<sui-grid>
							<sui-grid-row>
								<sui-grid-column :width="4">
									<b>Carrera: </b> <br />
									{{ alumno.carrera.nombre || '-' }}
								</sui-grid-column>
								<sui-grid-column :width="3">
									<b>Plan: </b> <br />
									{{ alumno.plan.nombre || '-' }}
								</sui-grid-column>
								<sui-grid-column :width="6">
									<b>Opción Titulación: </b> <br />
									{{ alumno.opcionTitulacion.descripcion || '-' }}
								</sui-grid-column>
								<sui-grid-column :width="3">
									<b>Semestre: </b> <br />
									{{ alumno.semestreActual || '-' }}
								</sui-grid-column>
							</sui-grid-row>
						</sui-grid>
						<sui-grid>
							<sui-grid-row>
								<sui-grid-column :width="4">
									<b>Nacionalidad: </b> <br />
									{{ alumno.nacionalidad.nombre || '-' }}
								</sui-grid-column>
								<sui-grid-column :width="6">
									<b>Correo: </b><br />
									{{ alumno.correoElectronico || '-' }}
									{{ alumno.correoVerificado ? '(Verificado)' : '' }}
								</sui-grid-column>
								<sui-grid-column :width="6">
									<b>Telefonos: </b> <br />
									{{ alumno.telefonos || '-' }}
								</sui-grid-column>
							</sui-grid-row>
						</sui-grid>
						<sui-grid v-if="alumno.expedienteFisico">
							<sui-grid-row>
								<sui-grid-column :width="6">
									<b>Número paquete: </b> <br />
									{{ alumno.numeroPaquete || '' }}
								</sui-grid-column>
								<sui-grid-column :width="6">
									<b>Observaciones: </b><br />
									{{ alumno.observacionesExpediente || '' }}
								</sui-grid-column>
							</sui-grid-row>
						</sui-grid>
						<sui-grid>
							<sui-grid-row>
								<sui-grid-column :width="16">
									<sui-button
										v-show="!alumno.estatus"
										:class="`ui button mini icon green `"
										icon="lock open"
										content="Activar"
										label-position="left"
										@click="activarModal"
									/>
									<sui-button
										v-show="alumno.estatus"
										:class="`ui button mini icon red `"
										icon="lock "
										content="Bloquear"
										label-position="left"
										@click="inactivar"
									/>
									<sui-button-group size="mini">
										<sui-button
											:class="
												`ui button mini icon green ${
													alumno.stepActive < 6 || isLoading ? 'disabled' : ''
												}`
											"
											icon="file alternate"
											content="No inconveniente"
											label-position="left"
											@click="generarNoInconvenientes"
										/>
										<sui-button
											v-show="
												!alumno.numeroOficio || alumno.numeroOficio === '0'
											"
											:class="
												`ui button mini green ${
													alumno.stepActive < 6 || isLoading ? 'disabled' : ''
												}`
											"
											icon="close"
											title="Documento no generado"
										/>
										<sui-button
											v-show="
												alumno.numeroOficio && alumno.numeroOficio !== '0'
											"
											:class="
												`ui button mini green ${
													alumno.stepActive < 6 || isLoading ? 'disabled' : ''
												}`
											"
											icon="check"
											title="Documento ya generado"
										/>
									</sui-button-group>
									&nbsp;
									<sui-button
										v-show="!alumno.prioritario"
										class="ui button mini icon yellow"
										icon="star "
										content="Prioritario"
										label-position="left"
										@click="establecerPrioritario"
									/>
									<sui-button
										v-show="alumno.prioritario"
										class="ui button mini icon yellow"
										icon="star outline"
										content="Quitar Prioritario"
										label-position="left"
										@click="quitarPrioritario"
									/>
									<sui-button
										class="ui button mini icon primary"
										icon="send"
										content="Enviar mensaje"
										label-position="left"
										@click="openModalMensaje"
									/>
									<sui-button
										class="ui button mini icon secondary"
										icon="history"
										content="Histórico"
										label-position="left"
										@click="openModalHistorico"
									/>
									<sui-button
										:class="
											`ui button mini icon success ${
												alumno.stepActive < 6 ||
												!alumno.numeroOficio ||
												alumno.numeroOficio === '0'
													? 'disabled'
													: ''
											}`
										"
										icon="download"
										content="Descargar todos"
										label-position="left"
										@click="descargarTodosArchivos"
									/>
									<sui-button
										:class="
											`ui button mini icon orange ${
												alumno.stepActive < 6 ||
												!alumno.numeroOficio ||
												alumno.numeroOficio === '0'
													? 'disabled'
													: ''
											}`
										"
										icon="folder"
										content="Expediente fisico"
										label-position="left"
										@click="openModalExpedienteFisico"
									/>
								</sui-grid-column>
							</sui-grid-row>
							<sui-grid-row>
								<sui-grid-column :width="16">
									<sui-button
										class="ui button mini icon green "
										icon="edit"
										content="Restablecer Opción Titulación"
										label-position="left"
										@click="resetearOpcionTitulacion"
									/>
									<sui-button-group size="mini">
										<sui-button
											class="ui button mini icon teal "
											icon="file image outline"
											content="Entregó fotografias"
											label-position="left"
											@click="cambiarTieneFotografias"
										/>
										<sui-button
											v-show="!alumno.tieneFotografias"
											class="ui button mini teal"
											icon="close"
											title="Fotografias no entregadas"
										/>
										<sui-button
											v-show="alumno.tieneFotografias"
											class="ui button mini teal"
											icon="check"
											title="Fotografias entregadas"
										/>
									</sui-button-group>
								</sui-grid-column>
							</sui-grid-row>
						</sui-grid>
					</p>
					<div class="ui inverted divider"></div>
					<div v-show="!isLoading" class="ui middle aligned divided list">
						<base-item-archivo
							v-for="file in camposDocumentos"
							:key="file"
							:nombre-archivo="getDocumentos[file].nombreArchivo"
							:documento-tramite-id="getDocumentos[file].id"
							:url-archivo="getDocumentos[file].urlArchivo"
							:mensaje="getDocumentos[file].observacion"
							:name="file"
							:titulo="
								file !== 'opcionTitulacion'
									? getDocumentos[file].descripcion
									: getAlumno.opcionTitulacion === '7'
									? 'CENEVAL RESULTADO Y TESTIMONIO'
									: 'PORTADA DEL PROYECTO'
							"
							:placeholder="
								file !== 'opcionTitulacion'
									? getDocumentos[file].descripcion
									: getAlumno.opcionTitulacion === '7'
									? 'CENEVAL RESULTADO Y TESTIMONIO'
									: 'PORTADA DEL PROYECTO'
							"
							:is-pending="isPending(file)"
							:is-valid="isValid(file)"
							:has-error="hasError(file)"
							@aprobar="aprobarArchivo"
							@rechazarConSolicitud="rechazarArchivoConSolicitud"
							@rechazar="rechazarArchivo"
							@subir="subirArchivo"
						/>
					</div>
				</sui-accordion-content>
			</template>
		</sui-accordion>
		<br />
		<div v-if="paginas > 1" class="ui right floated mini pagination menu">
			<a
				class="ui icon item active"
				:class="{ disabled: paginaActual <= 1 }"
				@click="cambiarPagina(1, paginaActual <= 1)"
			>
				<i class="left angle double icon"></i>
			</a>
			<a
				class="ui icon item active"
				:class="{ disabled: paginaActual <= 1 }"
				@click="cambiarPagina(paginaActual - 1, paginaActual <= 1)"
			>
				<i class="left angle icon"></i>
			</a>
			<a
				v-for="numero in rangoPaginasMostrar"
				:key="numero"
				class="ui item"
				:class="{ disabled: numero === paginaActual }"
				@click="
					cambiarPagina(
						numero,
						numero === paginas && paginas !== paginasMostrar
					)
				"
				>{{ numero }}</a
			>
			<a
				class="ui icon item active"
				:class="{ disabled: paginaActual >= paginas }"
				@click="cambiarPagina(paginaActual + 1, paginaActual >= paginas)"
			>
				<i class="right angle icon"></i>
			</a>
			<a
				class="ui icon item active"
				:class="{ disabled: paginaActual >= paginas }"
				@click="cambiarPagina(paginas, paginaActual >= paginas)"
			>
				<i class="right angle double icon"></i>
			</a>
		</div>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import Notification from '@utils/notification';
const EMAIL_DOMINIO_ANTERIOR = '@tectijuana.edu.mx';
const EMAIL_DOMINIO_ACTUAL = '@tijuana.tecnm.mx';

const dominioValido = (correoElectronico) =>
	(correoElectronico &&
		correoElectronico
			.trim()
			.toLowerCase()
			.endsWith(EMAIL_DOMINIO_ANTERIOR)) ||
	correoElectronico
		.trim()
		.toLowerCase()
		.endsWith(EMAIL_DOMINIO_ACTUAL);

export default {
	data() {
		return {
			alumnoActive: '',
			filter: '',
			correo: '',
			openMensaje: false,
			openCorreo: false,
			openHistorico: false,
			mensaje: '',
			paginaActual: 1,
			porPagina: 30,
			carrera: 0,
			paso: 3,
			bloquesMostrar: 10,
			openExpedienteFisico: false,
			expedienteFisico: false,
			numeroExpediente: '',
			observacionesExpediente: '',
			openPdfNoInconvenientes: false,
			openOpcionTitulacion: false,
			urlArchivoPdfNoInconvenientes: '',
			numeroPaquete: ''
		};
	},
	computed: {
		...mapGetters('oidc', ['oidcUser']),
		...mapGetters('alumno', [
			'getDocumentos',
			'getAlumno',
			'getAlumnos',
			'isLoading',
			'isAlumnoDeCambioOCombalidado',
			'getTotalAlumnos',
			'getMensajes',
			'getHistoricos',
			'isLoadingFormulario'
		]),
		camposDocumentos: function() {
			const campos = [];
			const stepActive = this.getAlumno.stepActive;
			for (var key in this.getDocumentos)
				if (this.getDocumentos[key].paso <= stepActive) campos.push(key);
			return campos;
		},
		elementosMostrar: function() {
			return this.getAlumnos;
		},
		endIndex: function() {
			const totalMuestra =
				this.totalElementos - this.startIndex + this.porPagina;
			return (
				this.startIndex + (totalMuestra > 0 ? this.porPagina : totalMuestra)
			);
		},
		startIndex: function() {
			return this.porPagina * (this.paginaActual - 1);
		},
		paginas: function() {
			const paginas = Math.ceil(this.totalElementos / this.porPagina);
			return Number(paginas !== 0 ? paginas : 1);
		},
		totalElementos: function() {
			return Number(this.getTotalAlumnos);
		},
		paginaEmpiezaBloque() {
			const diferencia = this.paginaActual - parseInt(this.bloquesMostrar / 2);
			return diferencia > 0 ? diferencia : 1;
		},
		paginasMostrar: function() {
			const paginasMostrarSinLimite =
				this.paginaEmpiezaBloque + this.bloquesMostrar;
			return paginasMostrarSinLimite < this.paginas
				? paginasMostrarSinLimite
				: this.paginas;
		},
		rangoPaginasMostrar: function() {
			return [
				...Array(this.paginasMostrar - this.paginaEmpiezaBloque + 1).keys()
			].map((i) => i + this.paginaEmpiezaBloque);
		}
	},
	watch: {
		carrera: function(val) {
			if (!val) val = 0;
			this.obtenerAlumnosPaginado({
				busqueda: this.filter.trim(),
				pagina: this.paginaActual,
				paso: this.paso,
				porPagina: this.porPagina,
				carreraId: val
			});
		},
		paso: function(val) {
			if (val == null) val = -1;
			this.obtenerAlumnosPaginado({
				busqueda: this.filter.trim(),
				pagina: this.paginaActual,
				paso: val,
				porPagina: this.porPagina,
				carreraId: this.carrera
			});
		}
	},
	mounted: function() {
		this.establecerTitulo('Inicio');
		this.establecerUrlAtras(null);
		this.inicializarOpcionesTituliacion();
		this.inicializarPlanes();
		this.obtenerAlumnosPaginado({
			busqueda: this.filter.trim(),
			pagina: this.paginaActual,
			paso: this.paso,
			porPagina: this.porPagina,
			carreraId: this.carrera
		});
	},
	methods: {
		...mapActions('app', ['establecerTitulo', 'establecerUrlAtras']),
		...mapActions('alumno', [
			'obtenerAlumno',
			'establecerAlumno',
			'siguientePaso',
			'obtenerAlumnos',
			'aprobarDocumento',
			'rechazarDocumento',
			'rechazarDocumentoConSolicitud',
			'subirDocumento',
			'establecerDocumentos',
			'todosLosDocumentoAprobados',
			'enviarMensajeAlumno',
			'obtenerAlumnosPaginado',
			'actualizarPrioritarioAlumno',
			'obtenerMensajesAlumno',
			'obtenerHistoricosAlumno',
			'activarAlumno',
			'inactivarAlumno',
			'generarDocumentoNoInconvenientes',
			'enviarDocumentoNoInconvenientes',
			'guardarExpedienteFisico',
			'restablecerOpcionTitulacion',
			'obtenerZipArchivos',
			'cambiarTieneFotografiasAlumno'
		]),
		...mapActions('opcionesTitulacion', ['inicializarOpcionesTituliacion']),
		...mapActions('planes', ['inicializarPlanes']),
		dominioValido(correo) {
			return dominioValido(correo);
		},
		onClickTitle(numeroControl) {
			if (this.alumnoActive !== numeroControl) {
				this.alumnoActive = numeroControl;
				this.obtenerAlumno(numeroControl);
			}
		},
		descargarTodosArchivos() {
			this.obtenerZipArchivos({
				numeroControl: this.getAlumno.numeroControl,
				onComplete: (response) => {
					const url = window.URL.createObjectURL(
						new Blob([response.data], { type: 'application/zip' })
					);
					const download = document.createElement('a');
					download.setAttribute('href', url);
					download.setAttribute('target', '_blank');
					download.setAttribute('rel', 'noreferrer');
					download.setAttribute('alt', this.getAlumno.numeroControl + '.zip');
					download.setAttribute('title', this.getAlumno.numeroControl + '.zip');
					download.setAttribute(
						'download',
						this.getAlumno.numeroControl + '.zip'
					);
					download.click();
				}
			});
			// window.URL = window.URL || window.webkitURL;
			// for (var key in this.camposDocumentos) {
			// 	const val = this.camposDocumentos[key];
			// 	if (this.isValid(val)) {

			// JSZipUtils.getBinaryContent(
			// 	this.getDocumentos[val].urlArchivo,
			// 	function(err, data) {
			// 		if (err) {
			// 			throw err; // or handle the error
			// 		}
			// 		zip.file(
			// 			this.getAlumno.numeroControl + '-' + val + '.pdf',
			// 			data,
			// 			{ binary: true }
			// 		);
			// 	}
			// );
			// const download = document.createElement('a');
			// download.setAttribute('href', this.getDocumentos[val].urlArchivo);
			// download.setAttribute('target', '_blank');
			// download.setAttribute('rel', 'noreferrer');
			// download.setAttribute(
			// 	'alt',
			// 	this.getAlumno.numeroControl + '-' + val
			// );
			// download.setAttribute(
			// 	'title',
			// 	this.getAlumno.numeroControl + '-' + val
			// );
			// download.setAttribute(
			// 	'download',
			// 	this.getAlumno.numeroControl + '-' + val
			// );
			// download.click();
			// 	}
			// }
			// zip.generateAsync({ type: 'blob' }).then(function(content) {
			// 	// see FileSaver.js
			// 	FileSaver.saveAs(content, this.getAlumno.numeroControl + '.zip');
			// });
		},
		buscar: function() {
			this.paginaActual = 1;
			this.obtenerAlumnosPaginado({
				busqueda: this.filter.trim(),
				pagina: this.paginaActual,
				paso: this.paso,
				porPagina: this.porPagina,
				carreraId: this.carrera
			});
		},
		cambiarPagina: function(pagina, disabled) {
			this.paginaActual = pagina;
			this.obtenerAlumnosPaginado({
				busqueda: this.filter.trim(),
				pagina: this.paginaActual,
				paso: this.paso,
				porPagina: this.porPagina,
				carreraId: this.carrera
			});
		},
		closeModalMensaje() {
			this.openMensaje = false;
			this.mensaje = '';
		},
		closeModalCorreo() {
			this.openCorreo = false;
			this.correo = '';
		},
		closePdfNoInconvenientes() {
			this.openPdfNoInconvenientes = false;
			this.urlArchivoPdfNoInconvenientes = ``;
			this.obtenerAlumno(this.getAlumno.numeroControl);
			this.obtenerAlumnosPaginado({
				busqueda: this.filter.trim(),
				pagina: this.paginaActual,
				paso: this.paso,
				porPagina: this.porPagina,
				carreraId: this.carrera
			});
		},
		closeModalOpcionTitulacion() {
			this.openOpcionTitulacion = false;
		},
		restablecerOpcionTitulacionAlumno() {
			const params = {};
			this.restablecerOpcionTitulacion({
				numeroControl: this.getAlumno.numeroControl,
				params,
				onComplete: (response) => {
					this.openOpcionTitulacion = false;
					this.obtenerAlumno(this.getAlumno.numeroControl);
					this.obtenerAlumnosPaginado({
						busqueda: this.filter.trim(),
						pagina: this.paginaActual,
						paso: this.paso,
						porPagina: this.porPagina,
						carreraId: this.carrera
					});
				}
			});
		},
		aceptarArchivoPdfNoInconvenientes() {
			const params = {};
			this.enviarDocumentoNoInconvenientes({
				numeroControl: this.getAlumno.numeroControl,
				params,
				onComplete: (response) => {
					this.urlArchivoPdfNoInconvenientes = ``;
					this.openPdfNoInconvenientes = false;
				}
			});
		},
		openModalMensaje() {
			this.openMensaje = true;
			this.obtenerMensajesAlumno({
				numeroControl: this.getAlumno.numeroControl,
				params: {
					prioritario: false
				}
			});
		},
		closeModalHistorico() {
			this.openHistorico = false;
		},
		openModalHistorico() {
			this.openHistorico = true;
			this.obtenerHistoricosAlumno({
				numeroControl: this.getAlumno.numeroControl,
				params: {
					prioritario: false
				}
			});
		},

		closeModalExpedienteFisico() {
			this.openExpedienteFisico = false;
		},
		guardarExpediente() {
			this.guardarExpedienteFisico({
				numeroControl: this.getAlumno.numeroControl,
				params: {
					expedienteFisico: true,
					numeroPaquete: this.numeroPaquete,
					observacionesExpediente: this.observacionesExpediente
				},
				onComplete: () => {
					this.openExpedienteFisico = false;
					this.obtenerAlumno(this.getAlumno.numeroControl);
					this.obtenerAlumnosPaginado({
						busqueda: this.filter.trim(),
						pagina: this.paginaActual,
						paso: this.paso,
						porPagina: this.porPagina,
						carreraId: this.carrera
					});
				}
			});
		},
		openModalExpedienteFisico() {
			this.openExpedienteFisico = true;
			this.expedienteFisico = this.getAlumno.expedienteFisico || '';
			this.numeroPaquete = this.getAlumno.numeroPaquete || '';
			this.observacionesExpediente =
				this.getAlumno.observacionesExpediente || '';
		},
		siguiente() {
			this.siguientePaso();
		},
		isPending(campo) {
			const datos = this.getDocumentos[campo];
			return !datos.subido || (datos.subido && !datos.verificado);
		},
		isValid(campo) {
			const datos = this.getDocumentos[campo];
			return datos.subido && datos.verificado && datos.valido;
		},
		hasError(campo) {
			const datos = this.getDocumentos[campo];
			return datos.subido && datos.verificado && !datos.valido;
		},
		face(stepActive, expedienteFisico) {
			switch (stepActive) {
				case 0:
					return 'ALUMNOS SIN ENTRAR';
				case 1:
					return 'VERIFICANDO INFORMACIÓN';
				case 2:
					return 'SUBIENDO ARCHIVOS';
				case 3:
					return 'REVISIÓN DOCUMENTOS';
				case 4:
					return 'SUBIENDO COMPROBANTE';
				case 5:
					return 'REVISIÓN COMPROBANTE';
				case 6:
					return !expedienteFisico ? 'TERMINADO' : 'TERMINADO CON E.TITULO';
			}
		},
		faceColorLabel(stepActive, expedienteFisico) {
			switch (stepActive) {
				case 0:
					return 'back';
				case 1:
					return 'back';
				case 2:
					return 'grey';
				case 3:
					return 'yellow';
				case 4:
					return 'black';
				case 5:
					return 'yellow';
				case 6:
					return !expedienteFisico ? 'green' : 'orange';
			}
		},
		enviarMensaje() {
			this.enviarMensajeAlumno({
				numeroControl: this.getAlumno.numeroControl,
				params: {
					mensaje: this.mensaje
				},
				onComplete: () => {
					this.openMensaje = false;
					this.mensaje = '';
				}
			});
		},
		establecerPrioritario() {
			this.actualizarPrioritarioAlumno({
				numeroControl: this.getAlumno.numeroControl,
				params: {
					prioritario: true
				}
			});
		},
		quitarPrioritario() {
			this.actualizarPrioritarioAlumno({
				numeroControl: this.getAlumno.numeroControl,
				params: {
					prioritario: false
				}
			});
		},
		aprobarArchivo(params) {
			this.aprobarDocumento({
				numeroControl: this.getAlumno.numeroControl,
				params,
				onComplete: () => {
					this.establecerDocumentos({
						...this.getDocumentos,
						[params.name]: {
							...this.getDocumentos[params.name],
							...params
						}
					});
					let valid = false;
					let maxStep = 0;
					for (var key in this.camposDocumentos) {
						const val = this.camposDocumentos[key];
						if (this.getDocumentos[val].paso > maxStep)
							maxStep = this.getDocumentos[val].paso;
						if (this.isValid(val)) {
							valid = true;
						} else {
							valid = false;
							break;
						}
					}
					if (valid) {
						this.todosLosDocumentoAprobados({
							numeroControl: this.getAlumno.numeroControl,
							paso: maxStep,
							params,
							onComplete: () => {}
						});
					}
				}
			});
		},
		rechazarArchivo(params) {
			this.rechazarDocumento({
				numeroControl: this.getAlumno.numeroControl,
				params,
				onComplete: () => {
					this.establecerDocumentos({
						...this.getDocumentos,
						[params.name]: {
							...this.getDocumentos[params.name],
							...params
						}
					});
				}
			});
		},
		rechazarArchivoConSolicitud(params) {
			this.rechazarDocumentoConSolicitud({
				numeroControl: this.getAlumno.numeroControl,
				params,
				onComplete: () => {
					this.establecerDocumentos({
						...this.getDocumentos,
						[params.name]: {
							...this.getDocumentos[params.name],
							...params
						}
					});
				}
			});
		},
		activarModal() {
			this.openCorreo = true;
			this.correo = this.getAlumno.correoElectronico;
		},
		activar() {
			const params = {
				correoElectronico: this.correo
			};
			this.activarAlumno({
				numeroControl: this.getAlumno.numeroControl,
				params,
				onComplete: () => {
					this.openCorreo = false;
					this.obtenerAlumnosPaginado({
						busqueda: this.filter.trim(),
						pagina: this.paginaActual,
						paso: this.paso,
						porPagina: this.porPagina,
						carreraId: this.carrera
					});
				}
			});
		},
		inactivar() {
			const params = {};
			this.inactivarAlumno({
				numeroControl: this.getAlumno.numeroControl,
				params,
				onComplete: () => {
					this.obtenerAlumnosPaginado({
						busqueda: this.filter.trim(),
						pagina: this.paginaActual,
						paso: this.paso,
						porPagina: this.porPagina,
						carreraId: this.carrera
					});
				}
			});
		},
		generarNoInconvenientes() {
			const params = {};
			if (!this.getAlumno.tieneFotografias)
				return Notification(
					'warn',
					'Es necesario que el alumno entregue las fotografías solicitadas'
				);
			this.generarDocumentoNoInconvenientes({
				numeroControl: this.getAlumno.numeroControl,
				params,
				onComplete: (response) => {
					const url = window.URL.createObjectURL(
						new Blob([response.data], { type: 'application/pdf' })
					);
					this.urlArchivoPdfNoInconvenientes = `${url}`;
					this.openPdfNoInconvenientes = true;
				}
			});
		},
		subirArchivo(event) {
			if (event && event.value) {
				this.subirDocumento({
					numeroControl: this.getAlumno.numeroControl,
					archivos: event.value,
					params: {
						id: this.getDocumentos[event.name].id,
						documentoTitulacionCodigo: event.name,
						nombreArchivo: event.value.name,
						subido: true,
						verificado: false,
						valido: false,
						version: parseInt(this.getDocumentos[event.name].version) + 1
					},
					onComplete: () => {
						this.obtenerAlumno(this.getAlumno.numeroControl);
					}
				});
			}
		},
		resetearOpcionTitulacion() {
			this.openOpcionTitulacion = true;
		},
		cambiarTieneFotografias() {
			this.cambiarTieneFotografiasAlumno({
				numeroControl: this.getAlumno.numeroControl,
				params: {},
				onComplete: () => {
					this.obtenerAlumno(this.getAlumno.numeroControl);
					this.obtenerAlumnosPaginado({
						busqueda: this.filter.trim(),
						pagina: this.paginaActual,
						paso: this.paso,
						porPagina: this.porPagina,
						carreraId: this.carrera
					});
				}
			});
		}
	}
};
</script>
